import { render, staticRenderFns } from "./ProjectFilesTableSmall.vue?vue&type=template&id=0ee16318"
import script from "./ProjectFilesTableSmall.vue?vue&type=script&lang=ts"
export * from "./ProjectFilesTableSmall.vue?vue&type=script&lang=ts"
import style0 from "./ProjectFilesTableSmall.vue?vue&type=style&index=0&id=0ee16318&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports